module.exports = __webpack_public_path__ + "img/FreelancerFeaturesDesktop.fa362cae.webp";